import { useEffect, useRef, useState } from 'react';
import { useNotification } from '../../../../hooks/useNotification';
import { useDataAuth } from '../../../../hooks/useDataAuth';
import { useForm } from '../../../../hooks/useForm';
import { useTranslation } from 'react-i18next';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import TableContainer from '@mui/material/TableContainer';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import PreviewIcon from '@mui/icons-material/Preview';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import TableBody from '@mui/material/TableBody';
import EditIcon from '@mui/icons-material/Edit';
import TableCell from '@mui/material/TableCell';
import Delete from '@mui/icons-material/Delete';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import Dialog from '@mui/material/Dialog';
import Table from '@mui/material/Table';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import moment from 'moment';

import { CreateFormMeetings } from '../../../../components/meetings/CreateFormMeetings';
import { TableAttachments } from '../../../../components/meetings/TableAttachments';
import { ActionButtons } from '../../../../components/others/ActionButtons';
import { DownloadFile } from '../../../../components/others/DownloadFile';
import { getContacts } from "../../../../services/meetings.service";
import { formatDateStandard } from '../../../../utils/date';

export const AddMeeting = ({
    idCompany,
    meetings,
    setMeetings,
    setLoading,
    edit,
    isView
}) => {
    const { t } = useTranslation();
    const [sendNotification] = useNotification();
    const [{ userSession }] = useDataAuth();
    const formService = useRef();

    const [indexMeeting, setIndexMeeting] = useState(null);
    const [openAddMeeting, setOpenAddMeeting] = useState(false);
    const [attachment, setAttachment] = useState([]);

    const [idEditing, setIdEditing] = useState(null);
    const [contacts, setContacts] = useState([]);

    const initialMeetingModel = {
        id_company: idCompany,
        id_contact: "",
        meeting_type: "",
        id_commercial_opportunity: "",
        id_commercial_visit: "",
        followed_up_by: [],
        meeting_objective: "",
        meeting_status: "",
        address: "",
        comments: "",
        meeting_date: moment(new Date()).format('YYYY-MM-DDTHH:mm'),
        attachments: attachment
    };
    const [modelMeeting, handleInputChange, handleDirectInputChange, setModelMeeting] = useForm(initialMeetingModel);

    const handleSubmit = async () => {
        const isValidFormContact = formService.current?.validateForm();
        if (!isValidFormContact) {
            sendNotification({
                msg: t("validation.requiredFieldsMissing"),
                variant: "error",
            });
            return;
        }
        const meetingWithAttachments = {
            ...modelMeeting,
            attachments: attachment,
        };
        setMeetings((prevMeetings) => {
            if (indexMeeting !== null) {
                const updated = [...prevMeetings];
                updated[indexMeeting] = meetingWithAttachments;
                return updated;
            } else {
                return [...prevMeetings, meetingWithAttachments];
            }
        });
        setIndexMeeting(null);
        setModelMeeting(initialMeetingModel);
        setAttachment([]);
        handleAdd();
    };


    const handleMeeting = (index) => {
        const meeting = meetings[index];
        setIdEditing(meeting.id_commercial_visit)
        setIndexMeeting(index);
        setModelMeeting(meeting);
        setAttachment(meeting.attachments || []);
        handleAdd();
    };


    const handleDeleteMeeting = (index) => {
        setMeetings((prevMeetings) => prevMeetings.filter((_, i) => i !== index));
    };
    const handleAdd = (edit = false) => {
        if (edit) {
            setIdEditing(null)
            setIndexMeeting(null);
            setModelMeeting(initialMeetingModel);
            setAttachment([]);
        }
        setOpenAddMeeting(!openAddMeeting)
    };

    useEffect(() => {
        const fetchFollowedUpBy = async () => {
            const contactsResponse = await getContacts(userSession.token);
            setContacts(contactsResponse.data);
        }
        fetchFollowedUpBy();
    }, [userSession.token]);

    return (
        <>
            <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <Typography variant="h6">
                        {t("meeting.tracing")}
                    </Typography>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }} display="flex" justifyContent="flex-end" alignItems="center">
                    <Tooltip title={t("add")} placement="top" arrow>
                        <IconButton
                            aria-label="add"
                            onClick={() => handleAdd(true)}
                            disabled={isView}
                        >
                            <PlaylistAddIcon color="primary" />
                        </IconButton>
                    </Tooltip>
                </Grid>
            </Grid>

            <Grid size={{ xs: 12 }}>
                <TableContainer component={Paper} sx={{ mt: 2, maxHeight: 400 }}>
                    <Table>
                        <TableHead sx={{ backgroundColor: '#e0e0e0' }}>
                            <TableRow>
                                <TableCell>Acciones</TableCell>
                                <TableCell>Contacto</TableCell>
                                <TableCell>Estado</TableCell>
                                <TableCell>Tipo Seguimiento</TableCell>
                                <TableCell>Fecha Reunión</TableCell>
                                <TableCell>Objetivo</TableCell>
                                <TableCell>Adjuntos</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {meetings.length > 0 ? (
                                meetings.map((item, index) => (
                                    <TableRow key={index}>
                                        <TableCell>
                                            <Tooltip title={isView ? "Ver" : t("edit")} placement="top" arrow>
                                                <IconButton onClick={() => handleMeeting(index)}>
                                                    {isView ?
                                                        <PreviewIcon color="primary" />
                                                        :
                                                        <EditIcon color="primary" />
                                                    }
                                                </IconButton>
                                            </Tooltip>

                                            {!edit && (
                                                <Tooltip title={t("delete")}>
                                                    <IconButton color="error" onClick={() => handleDeleteMeeting(index)}>
                                                        <Delete />
                                                    </IconButton>
                                                </Tooltip>
                                            )}
                                        </TableCell>
                                        <TableCell maxWidth={200}>
                                            {(() => {
                                                const contact = contacts.find((contact) => item.id_contact === contact.id_contact);
                                                return contact ? `${contact.name} - ${contact.email}` : 'Contacto no existente';
                                            })()}
                                        </TableCell>
                                        <TableCell>{item.meeting_status}</TableCell>
                                        <TableCell>{item.meeting_type}</TableCell>
                                        <TableCell>{formatDateStandard(item.meeting_date)}</TableCell>
                                        <TableCell>{item.meeting_objective}</TableCell>
                                        <TableCell>
                                            {item.url?.trim() ? (
                                                item.url?.split('|').map((path, i) => {
                                                    const cleanPath = path.trim();
                                                    if (!cleanPath) return null;
                                                    const fileName = cleanPath.split('/').pop();
                                                    return (
                                                        <Box key={i} display="flex" alignItems="center" gap={0.5} mb={0.5}>
                                                            <DownloadFile
                                                                path={cleanPath}
                                                                bucket={item.bucket}
                                                                idFlow={'900114098-API-DOWNLOAD-BASE64'}
                                                            />
                                                            {fileName}
                                                        </Box>
                                                    );
                                                })
                                            ) : item.attachments?.length ? (
                                                item.attachments.map((file, i) => (
                                                    <Box key={i} display="flex" alignItems="center" gap={0.5} mb={0.5}>
                                                        <DownloadFile
                                                            name={file.name}
                                                            base64={file.bytes}
                                                        />
                                                        {file.name}
                                                    </Box>
                                                ))
                                            ) : null}
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={6} align="center">
                                        No hay seguimientos aún.
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>

            <Dialog open={openAddMeeting} onClose={handleAdd} fullWidth maxWidth="md">
                <DialogTitle>
                    {t("meeting.tracing")}
                </DialogTitle>
                <DialogContent dividers>
                    <CreateFormMeetings
                        ref={formService}
                        dto={modelMeeting}
                        handleInputChange={handleInputChange}
                        handleDirectInputChange={handleDirectInputChange}
                        setLoading={setLoading}
                        isEdit={edit}
                        viewOpportunity={true}
                        isView={isView}
                    />

                    <Grid container spacing={1} sx={{ mt: 2 }}>
                        <TableAttachments
                            attachment={attachment}
                            setAttachment={setAttachment}
                            edit={edit}
                            id={idEditing}
                            isView={isView}
                        />
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <ActionButtons
                        onCancel={handleAdd}
                        onSubmit={handleSubmit}
                        disabledSubmit={isView}
                    />
                </DialogActions>
            </Dialog>
        </>
    );
};
